import { toastr } from 'react-redux-toastr';
import { updatePassword } from '../../../../actions/shop/forgotPassword/updatePassword';

async function submit(values, dispatch) {
  if (values.newPassword != values.confirmPassword) toastr.error("Error", "Password mismatch.Please try again.");
  else dispatch(updatePassword(values.email, values.newPassword, values.token))
}

export default submit;